import { combineReducers } from "@reduxjs/toolkit";
import profile from "./profileSlice";

const userReducers = combineReducers({
  profile,
});

export default userReducers;
